// Generator-discovered file route for the creatives library. Component lives in
// `src/ad/routes/creatives.tsx` (Module K / K3).
import { createFileRoute } from '@tanstack/react-router';
import { CreativesRouteComponent } from '@/ad/routes/creatives';

export const Route = createFileRoute('/_authenticated/ad/creatives')({
  component: CreativesRouteComponent,
});
